// List of Timezones grouped by continent
// A standard timezone list defined by IANA as tz database
// More information: http://en.wikipedia.org/wiki/List_of_tz_database_time_zones
import _t from 'i18n!nls/common';

const timezones = () => ({
  Africa: {
    groupName: _t('Africa'),
    zones: {
      [_t('Abidjan')]: 'Africa/Abidjan',
      [_t('Accra')]: 'Africa/Accra',
      [_t('Addis Ababa')]: 'Africa/Addis_Ababa',
      [_t('Algiers')]: 'Africa/Algiers',
      [_t('Asmara')]: 'Africa/Asmara',
      [_t('Bamako')]: 'Africa/Bamako',
      [_t('Bangui')]: 'Africa/Bangui',
      [_t('Banjul')]: 'Africa/Banjul',
      [_t('Bissau')]: 'Africa/Bissau',
      [_t('Blantyre')]: 'Africa/Blantyre',
      [_t('Brazzaville')]: 'Africa/Brazzaville',
      [_t('Bujumbura')]: 'Africa/Bujumbura',
      [_t('Cairo')]: 'Africa/Cairo',
      [_t('Casablanca')]: 'Africa/Casablanca',
      [_t('Ceuta')]: 'Africa/Ceuta',
      [_t('Conakry')]: 'Africa/Conakry',
      [_t('Dakar')]: 'Africa/Dakar',
      [_t('Dar es Salaam')]: 'Africa/Dar_es_Salaam',
      [_t('Djibouti')]: 'Africa/Djibouti',
      [_t('Douala')]: 'Africa/Douala',
      [_t('El Aaiun')]: 'Africa/El_Aaiun',
      [_t('Freetown')]: 'Africa/Freetown',
      [_t('Gaborone')]: 'Africa/Gaborone',
      [_t('Harare')]: 'Africa/Harare',
      [_t('Johannesburg')]: 'Africa/Johannesburg',
      [_t('Juba')]: 'Africa/Juba',
      [_t('Kampala')]: 'Africa/Kampala',
      [_t('Khartoum')]: 'Africa/Khartoum',
      [_t('Kigali')]: 'Africa/Kigali',
      [_t('Kinshasa')]: 'Africa/Kinshasa',
      [_t('Lagos')]: 'Africa/Lagos',
      [_t('Libreville')]: 'Africa/Libreville',
      [_t('Lome')]: 'Africa/Lome',
      [_t('Luanda')]: 'Africa/Luanda',
      [_t('Lubumbashi')]: 'Africa/Lubumbashi',
      [_t('Lusaka')]: 'Africa/Lusaka',
      [_t('Malabo')]: 'Africa/Malabo',
      [_t('Maputo')]: 'Africa/Maputo',
      [_t('Maseru')]: 'Africa/Maseru',
      [_t('Mbabane')]: 'Africa/Mbabane',
      [_t('Mogadishu')]: 'Africa/Mogadishu',
      [_t('Monrovia')]: 'Africa/Monrovia',
      [_t('Nairobi')]: 'Africa/Nairobi',
      [_t('Ndjamena')]: 'Africa/Ndjamena',
      [_t('Niamey')]: 'Africa/Niamey',
      [_t('Nouakchott')]: 'Africa/Nouakchott',
      [_t('Ouagadougou')]: 'Africa/Ouagadougou',
      [_t('Porto-Novo')]: 'Africa/Porto-Novo',
      [_t('Sao Tome')]: 'Africa/Sao_Tome',
      [_t('Tripoli')]: 'Africa/Tripoli',
      [_t('Tunis')]: 'Africa/Tunis',
      [_t('Windhoek')]: 'Africa/Windhoek',
    },
  },

  America: {
    groupName: _t('America'),
    zones: {
      [_t('Adak')]: 'America/Adak',
      [_t('Anchorage')]: 'America/Anchorage',
      [_t('Anguilla')]: 'America/Anguilla',
      [_t('Antigua')]: 'America/Antigua',
      [_t('Araguaina')]: 'America/Araguaina',
      [_t('Buenos Aires')]: 'America/Argentina/Buenos_Aires',
      [_t('Catamarca')]: 'America/Argentina/Catamarca',
      [_t('Cordoba')]: 'America/Argentina/Cordoba',
      [_t('Jujuy')]: 'America/Argentina/Jujuy',
      [_t('La Rioja')]: 'America/Argentina/La_Rioja',
      [_t('Mendoza')]: 'America/Argentina/Mendoza',
      [_t('Rio Gallegos')]: 'America/Argentina/Rio_Gallegos',
      [_t('Salta')]: 'America/Argentina/Salta',
      [_t('San Juan')]: 'America/Argentina/San_Juan',
      [_t('San Luis')]: 'America/Argentina/San_Luis',
      [_t('Tucuman')]: 'America/Argentina/Tucuman',
      [_t('Ushuaia')]: 'America/Argentina/Ushuaia',
      [_t('Aruba')]: 'America/Aruba',
      [_t('Asuncion')]: 'America/Asuncion',
      [_t('Atikokan')]: 'America/Atikokan',
      [_t('Bahia')]: 'America/Bahia',
      [_t('Bahia Banderas')]: 'America/Bahia_Banderas',
      [_t('Barbados')]: 'America/Barbados',
      [_t('Belem')]: 'America/Belem',
      [_t('Belize')]: 'America/Belize',
      [_t('Blanc-Sablon')]: 'America/Blanc-Sablon',
      [_t('Boa Vista')]: 'America/Boa_Vista',
      [_t('Bogota')]: 'America/Bogota',
      [_t('Boise')]: 'America/Boise',
      [_t('Cambridge Bay')]: 'America/Cambridge_Bay',
      [_t('Campo Grande')]: 'America/Campo_Grande',
      [_t('Cancun')]: 'America/Cancun',
      [_t('Caracas')]: 'America/Caracas',
      [_t('Cayenne')]: 'America/Cayenne',
      [_t('Cayman')]: 'America/Cayman',
      [_t('Chicago')]: 'America/Chicago',
      [_t('Chihuahua')]: 'America/Chihuahua',
      [_t('Costa Rica')]: 'America/Costa_Rica',
      [_t('Creston')]: 'America/Creston',
      [_t('Cuiaba')]: 'America/Cuiaba',
      [_t('Curacao')]: 'America/Curacao',
      [_t('Danmarkshavn')]: 'America/Danmarkshavn',
      [_t('Dawson')]: 'America/Dawson',
      [_t('Dawson Creek')]: 'America/Dawson_Creek',
      [_t('Denver')]: 'America/Denver',
      [_t('Detroit')]: 'America/Detroit',
      [_t('Dominica')]: 'America/Dominica',
      [_t('Edmonton')]: 'America/Edmonton',
      [_t('Eirunepe')]: 'America/Eirunepe',
      [_t('El Salvador')]: 'America/El_Salvador',
      [_t('Fortaleza')]: 'America/Fortaleza',
      [_t('Glace Bay')]: 'America/Glace_Bay',
      [_t('Godthab')]: 'America/Godthab',
      [_t('Goose Bay')]: 'America/Goose_Bay',
      [_t('Grand Turk')]: 'America/Grand_Turk',
      [_t('Grenada')]: 'America/Grenada',
      [_t('Guadeloupe')]: 'America/Guadeloupe',
      [_t('Guatemala')]: 'America/Guatemala',
      [_t('Guayaquil')]: 'America/Guayaquil',
      [_t('Guyana')]: 'America/Guyana',
      [_t('Halifax')]: 'America/Halifax',
      [_t('Havana')]: 'America/Havana',
      [_t('Hermosillo')]: 'America/Hermosillo',
      [_t('Indianapolis')]: 'America/Indiana/Indianapolis',
      [_t('Knox')]: 'America/Indiana/Knox',
      [_t('Marengo')]: 'America/Indiana/Marengo',
      [_t('Petersburg')]: 'America/Indiana/Petersburg',
      [_t('Tell City')]: 'America/Indiana/Tell_City',
      [_t('Vevay')]: 'America/Indiana/Vevay',
      [_t('Vincennes')]: 'America/Indiana/Vincennes',
      [_t('Winamac')]: 'America/Indiana/Winamac',
      [_t('Inuvik')]: 'America/Inuvik',
      [_t('Iqaluit')]: 'America/Iqaluit',
      [_t('Jamaica')]: 'America/Jamaica',
      [_t('Juneau')]: 'America/Juneau',
      [_t('Louisville')]: 'America/Kentucky/Louisville',
      [_t('Monticello')]: 'America/Kentucky/Monticello',
      [_t('Kralendijk')]: 'America/Kralendijk',
      [_t('La Paz')]: 'America/La_Paz',
      [_t('Lima')]: 'America/Lima',
      [_t('Los Angeles')]: 'America/Los_Angeles',
      [_t('Lower Princes')]: 'America/Lower_Princes',
      [_t('Maceio')]: 'America/Maceio',
      [_t('Managua')]: 'America/Managua',
      [_t('Manaus')]: 'America/Manaus',
      [_t('Marigot')]: 'America/Marigot',
      [_t('Martinique')]: 'America/Martinique',
      [_t('Matamoros')]: 'America/Matamoros',
      [_t('Mazatlan')]: 'America/Mazatlan',
      [_t('Menominee')]: 'America/Menominee',
      [_t('Merida')]: 'America/Merida',
      [_t('Metlakatla')]: 'America/Metlakatla',
      [_t('Mexico City')]: 'America/Mexico_City',
      [_t('Miquelon')]: 'America/Miquelon',
      [_t('Moncton')]: 'America/Moncton',
      [_t('Monterrey')]: 'America/Monterrey',
      [_t('Montevideo')]: 'America/Montevideo',
      [_t('Montreal')]: 'America/Montreal',
      [_t('Montserrat')]: 'America/Montserrat',
      [_t('Nassau')]: 'America/Nassau',
      [_t('New York')]: 'America/New_York',
      [_t('Nipigon')]: 'America/Nipigon',
      [_t('Nome')]: 'America/Nome',
      [_t('Noronha')]: 'America/Noronha',
      [_t('Beulah')]: 'America/North_Dakota/Beulah',
      [_t('Center')]: 'America/North_Dakota/Center',
      [_t('New Salem')]: 'America/North_Dakota/New_Salem',
      [_t('Ojinaga')]: 'America/Ojinaga',
      [_t('Panama')]: 'America/Panama',
      [_t('Pangnirtung')]: 'America/Pangnirtung',
      [_t('Paramaribo')]: 'America/Paramaribo',
      [_t('Phoenix')]: 'America/Phoenix',
      [_t('Port-au-Prince')]: 'America/Port-au-Prince',
      [_t('Port of Spain')]: 'America/Port_of_Spain',
      [_t('Porto Velho')]: 'America/Porto_Velho',
      [_t('Puerto Rico')]: 'America/Puerto_Rico',
      [_t('Rainy River')]: 'America/Rainy_River',
      [_t('Rankin Inlet')]: 'America/Rankin_Inlet',
      [_t('Recife')]: 'America/Recife',
      [_t('Regina')]: 'America/Regina',
      [_t('Resolute')]: 'America/Resolute',
      [_t('Rio Branco')]: 'America/Rio_Branco',
      [_t('Santa Isabel')]: 'America/Santa_Isabel',
      [_t('Santarem')]: 'America/Santarem',
      [_t('Santiago')]: 'America/Santiago',
      [_t('Santo Domingo')]: 'America/Santo_Domingo',
      [_t('Sao Paulo')]: 'Etc/GMT+3',
      [_t('Scoresbysund')]: 'America/Scoresbysund',
      [_t('Shiprock')]: 'America/Shiprock',
      [_t('Sitka')]: 'America/Sitka',
      [_t('St Barthelemy')]: 'America/St_Barthelemy',
      [_t('St Johns')]: 'America/St_Johns',
      [_t('St Kitts')]: 'America/St_Kitts',
      [_t('St Lucia')]: 'America/St_Lucia',
      [_t('St Thomas')]: 'America/St_Thomas',
      [_t('St Vincent')]: 'America/St_Vincent',
      [_t('Swift Current')]: 'America/Swift_Current',
      [_t('Tegucigalpa')]: 'America/Tegucigalpa',
      [_t('Thule')]: 'America/Thule',
      [_t('Thunder Bay')]: 'America/Thunder_Bay',
      [_t('Tijuana')]: 'America/Tijuana',
      [_t('Toronto')]: 'America/Toronto',
      [_t('Tortola')]: 'America/Tortola',
      [_t('Vancouver')]: 'America/Vancouver',
      [_t('Whitehorse')]: 'America/Whitehorse',
      [_t('Winnipeg')]: 'America/Winnipeg',
      [_t('Yakutat')]: 'America/Yakutat',
      [_t('Yellowknife')]: 'America/Yellowknife',
    },
  },

  Antarctica: {
    groupName: _t('Antarctica'),
    zones: {
      [_t('Casey')]: 'Antarctica/Casey',
      [_t('Davis')]: 'Antarctica/Davis',
      [_t('DumontDUrville')]: 'Antarctica/DumontDUrville',
      [_t('Macquarie')]: 'Antarctica/Macquarie',
      [_t('Mawson')]: 'Antarctica/Mawson',
      [_t('McMurdo')]: 'Antarctica/McMurdo',
      [_t('Palmer')]: 'Antarctica/Palmer',
      [_t('Rothera')]: 'Antarctica/Rothera',
      [_t('South Pole')]: 'Antarctica/South_Pole',
      [_t('Syowa')]: 'Antarctica/Syowa',
      [_t('Vostok')]: 'Antarctica/Vostok',
    },
  },

  Arctic: {
    groupName: _t('Arctic'),
    zones: {
      [_t('Longyearbyen')]: 'Arctic/Longyearbyen',
    },
  },

  Asia: {
    groupName: _t('Asia'),
    zones: {
      [_t('Abu Dhabi')]: 'Asia/Dubai',
      [_t('Aden')]: 'Asia/Aden',
      [_t('Almaty')]: 'Asia/Almaty',
      [_t('Amman')]: 'Asia/Amman',
      [_t('Anadyr')]: 'Asia/Anadyr',
      [_t('Aqtau')]: 'Asia/Aqtau',
      [_t('Aqtobe')]: 'Asia/Aqtobe',
      [_t('Ashgabat')]: 'Asia/Ashgabat',
      [_t('Baghdad')]: 'Asia/Baghdad',
      [_t('Bahrain')]: 'Asia/Bahrain',
      [_t('Baku')]: 'Asia/Baku',
      [_t('Bangkok')]: 'Asia/Bangkok',
      [_t('Beirut')]: 'Asia/Beirut',
      [_t('Bishkek')]: 'Asia/Bishkek',
      [_t('Brunei')]: 'Asia/Brunei',
      [_t('Choibalsan')]: 'Asia/Choibalsan',
      [_t('Chongqing')]: 'Asia/Chongqing',
      [_t('Colombo')]: 'Asia/Colombo',
      [_t('Damascus')]: 'Asia/Damascus',
      [_t('Dhaka')]: 'Asia/Dhaka',
      [_t('Dili')]: 'Asia/Dili',
      [_t('Dubai')]: 'Asia/Dubai',
      [_t('Dushanbe')]: 'Asia/Dushanbe',
      [_t('Gaza')]: 'Asia/Gaza',
      [_t('Harbin')]: 'Asia/Harbin',
      [_t('Hebron')]: 'Asia/Hebron',
      [_t('Ho Chi Minh')]: 'Asia/Ho_Chi_Minh',
      [_t('Hong Kong')]: 'Asia/Hong_Kong',
      [_t('Hovd')]: 'Asia/Hovd',
      [_t('Irkutsk')]: 'Asia/Irkutsk',
      [_t('Jakarta')]: 'Asia/Jakarta',
      [_t('Jayapura')]: 'Asia/Jayapura',
      [_t('Jerusalem')]: 'Asia/Jerusalem',
      [_t('Kabul')]: 'Asia/Kabul',
      [_t('Kamchatka')]: 'Asia/Kamchatka',
      [_t('Karachi')]: 'Asia/Karachi',
      [_t('Kashgar')]: 'Asia/Kashgar',
      [_t('Kathmandu')]: 'Asia/Kathmandu',
      [_t('Kolkata')]: 'Asia/Kolkata',
      [_t('Krasnoyarsk')]: 'Asia/Krasnoyarsk',
      [_t('Kuala Lumpur')]: 'Asia/Kuala_Lumpur',
      [_t('Kuching')]: 'Asia/Kuching',
      [_t('Kuwait')]: 'Asia/Kuwait',
      [_t('Macau')]: 'Asia/Macau',
      [_t('Magadan')]: 'Asia/Magadan',
      [_t('Makassar')]: 'Asia/Makassar',
      [_t('Manila')]: 'Asia/Manila',
      [_t('Muscat')]: 'Asia/Muscat',
      [_t('Nicosia')]: 'Asia/Nicosia',
      [_t('Novokuznetsk')]: 'Asia/Novokuznetsk',
      [_t('Novosibirsk')]: 'Asia/Novosibirsk',
      [_t('Omsk')]: 'Asia/Omsk',
      [_t('Oral')]: 'Asia/Oral',
      [_t('Phnom Penh')]: 'Asia/Phnom_Penh',
      [_t('Pontianak')]: 'Asia/Pontianak',
      [_t('Pyongyang')]: 'Asia/Pyongyang',
      [_t('Qatar')]: 'Asia/Qatar',
      [_t('Qyzylorda')]: 'Asia/Qyzylorda',
      [_t('Rangoon')]: 'Asia/Rangoon',
      [_t('Riyadh')]: 'Asia/Riyadh',
      [_t('Sakhalin')]: 'Asia/Sakhalin',
      [_t('Samarkand')]: 'Asia/Samarkand',
      [_t('Seoul')]: 'Asia/Seoul',
      [_t('Shanghai')]: 'Asia/Shanghai',
      [_t('Singapore')]: 'Asia/Singapore',
      [_t('Taipei')]: 'Asia/Taipei',
      [_t('Tashkent')]: 'Asia/Tashkent',
      [_t('Tbilisi')]: 'Asia/Tbilisi',
      [_t('Tehran')]: 'Asia/Tehran',
      [_t('Thimphu')]: 'Asia/Thimphu',
      [_t('Tokyo')]: 'Asia/Tokyo',
      [_t('Ulaanbaatar')]: 'Asia/Ulaanbaatar',
      [_t('Urumqi')]: 'Asia/Urumqi',
      [_t('Vientiane')]: 'Asia/Vientiane',
      [_t('Vladivostok')]: 'Asia/Vladivostok',
      [_t('Yakutsk')]: 'Asia/Yakutsk',
      [_t('Yekaterinburg')]: 'Asia/Yekaterinburg',
      [_t('Yerevan')]: 'Asia/Yerevan',
    },
  } as const,

  Atlantic: {
    groupName: _t('Atlantic'),
    zones: {
      [_t('Azores')]: 'Atlantic/Azores',
      [_t('Bermuda')]: 'Atlantic/Bermuda',
      [_t('Canary')]: 'Atlantic/Canary',
      [_t('Cape Verde')]: 'Atlantic/Cape_Verde',
      [_t('Faroe')]: 'Atlantic/Faroe',
      [_t('Madeira')]: 'Atlantic/Madeira',
      [_t('Reykjavik')]: 'Atlantic/Reykjavik',
      [_t('South Georgia')]: 'Atlantic/South_Georgia',
      [_t('St Helena')]: 'Atlantic/St_Helena',
      [_t('Stanley')]: 'Atlantic/Stanley',
    },
  } as const,

  Australia: {
    groupName: _t('Australia'),
    zones: {
      [_t('Adelaide')]: 'Australia/Adelaide',
      [_t('Brisbane')]: 'Australia/Brisbane',
      [_t('Broken Hill')]: 'Australia/Broken_Hill',
      [_t('Currie')]: 'Australia/Currie',
      [_t('Darwin')]: 'Australia/Darwin',
      [_t('Eucla')]: 'Australia/Eucla',
      [_t('Hobart')]: 'Australia/Hobart',
      [_t('Lindeman')]: 'Australia/Lindeman',
      [_t('Lord Howe')]: 'Australia/Lord_Howe',
      [_t('Melbourne')]: 'Australia/Melbourne',
      [_t('Perth')]: 'Australia/Perth',
      [_t('Sydney')]: 'Australia/Sydney',
    },
  } as const,

  Europe: {
    groupName: _t('Europe'),
    zones: {
      [_t('Amsterdam')]: 'Europe/Amsterdam',
      [_t('Andorra')]: 'Europe/Andorra',
      [_t('Athens')]: 'Europe/Athens',
      [_t('Belgrade')]: 'Europe/Belgrade',
      [_t('Berlin')]: 'Europe/Berlin',
      [_t('Bratislava')]: 'Europe/Bratislava',
      [_t('Brussels')]: 'Europe/Brussels',
      [_t('Bucharest')]: 'Europe/Bucharest',
      [_t('Budapest')]: 'Europe/Budapest',
      [_t('Chisinau')]: 'Europe/Chisinau',
      [_t('Copenhagen')]: 'Europe/Copenhagen',
      [_t('Dublin')]: 'Europe/Dublin',
      [_t('Gibraltar')]: 'Europe/Gibraltar',
      [_t('Guernsey')]: 'Europe/Guernsey',
      [_t('Helsinki')]: 'Europe/Helsinki',
      [_t('Isle of Man')]: 'Europe/Isle_of_Man',
      [_t('Istanbul')]: 'Europe/Istanbul',
      [_t('Jersey')]: 'Europe/Jersey',
      [_t('Kaliningrad')]: 'Europe/Kaliningrad',
      [_t('Kyiv')]: 'Europe/Kiev',
      [_t('Lisbon')]: 'Europe/Lisbon',
      [_t('Ljubljana')]: 'Europe/Ljubljana',
      [_t('London')]: 'Europe/London',
      [_t('Luxembourg')]: 'Europe/Luxembourg',
      [_t('Madrid')]: 'Europe/Madrid',
      [_t('Malta')]: 'Europe/Malta',
      [_t('Mariehamn')]: 'Europe/Mariehamn',
      [_t('Minsk')]: 'Europe/Minsk',
      [_t('Monaco')]: 'Europe/Monaco',
      [_t('Moscow')]: 'Europe/Moscow',
      [_t('Oslo')]: 'Europe/Oslo',
      [_t('Paris')]: 'Europe/Paris',
      [_t('Podgorica')]: 'Europe/Podgorica',
      [_t('Prague')]: 'Europe/Prague',
      [_t('Riga')]: 'Europe/Riga',
      [_t('Rome')]: 'Europe/Rome',
      [_t('Samara')]: 'Europe/Samara',
      [_t('San Marino')]: 'Europe/San_Marino',
      [_t('Sarajevo')]: 'Europe/Sarajevo',
      [_t('Simferopol')]: 'Europe/Simferopol',
      [_t('Skopje')]: 'Europe/Skopje',
      [_t('Sofia')]: 'Europe/Sofia',
      [_t('Stockholm')]: 'Europe/Stockholm',
      [_t('Tallinn')]: 'Europe/Tallinn',
      [_t('Tirane')]: 'Europe/Tirane',
      [_t('Uzhgorod')]: 'Europe/Uzhgorod',
      [_t('Vaduz')]: 'Europe/Vaduz',
      [_t('Vatican')]: 'Europe/Vatican',
      [_t('Vienna')]: 'Europe/Vienna',
      [_t('Vilnius')]: 'Europe/Vilnius',
      [_t('Volgograd')]: 'Europe/Volgograd',
      [_t('Warsaw')]: 'Europe/Warsaw',
      [_t('Zagreb')]: 'Europe/Zagreb',
      [_t('Zaporozhye')]: 'Europe/Zaporozhye',
      [_t('Zurich')]: 'Europe/Zurich',
    },
  } as const,

  Indian: {
    groupName: _t('Indian'),
    zones: {
      [_t('Antananarivo')]: 'Indian/Antananarivo',
      [_t('Chagos')]: 'Indian/Chagos',
      [_t('Christmas')]: 'Indian/Christmas',
      [_t('Cocos')]: 'Indian/Cocos',
      [_t('Comoro')]: 'Indian/Comoro',
      [_t('Kerguelen')]: 'Indian/Kerguelen',
      [_t('Mahe')]: 'Indian/Mahe',
      [_t('Maldives')]: 'Indian/Maldives',
      [_t('Mauritius')]: 'Indian/Mauritius',
      [_t('Mayotte')]: 'Indian/Mayotte',
      [_t('Reunion')]: 'Indian/Reunion',
    },
  } as const,

  Pacific: {
    groupName: _t('Pacific'),
    zones: {
      [_t('Apia')]: 'Pacific/Apia',
      [_t('Auckland')]: 'Pacific/Auckland',
      [_t('Chatham')]: 'Pacific/Chatham',
      [_t('Chuuk')]: 'Pacific/Chuuk',
      [_t('Easter')]: 'Pacific/Easter',
      [_t('Efate')]: 'Pacific/Efate',
      [_t('Enderbury')]: 'Pacific/Enderbury',
      [_t('Fakaofo')]: 'Pacific/Fakaofo',
      [_t('Fiji')]: 'Pacific/Fiji',
      [_t('Funafuti')]: 'Pacific/Funafuti',
      [_t('Galapagos')]: 'Pacific/Galapagos',
      [_t('Gambier')]: 'Pacific/Gambier',
      [_t('Guadalcanal')]: 'Pacific/Guadalcanal',
      [_t('Guam')]: 'Pacific/Guam',
      [_t('Honolulu')]: 'Pacific/Honolulu',
      [_t('Johnston')]: 'Pacific/Johnston',
      [_t('Kiritimati')]: 'Pacific/Kiritimati',
      [_t('Kosrae')]: 'Pacific/Kosrae',
      [_t('Kwajalein')]: 'Pacific/Kwajalein',
      [_t('Majuro')]: 'Pacific/Majuro',
      [_t('Marquesas')]: 'Pacific/Marquesas',
      [_t('Midway')]: 'Pacific/Midway',
      [_t('Nauru')]: 'Pacific/Nauru',
      [_t('Niue')]: 'Pacific/Niue',
      [_t('Norfolk')]: 'Pacific/Norfolk',
      [_t('Noumea')]: 'Pacific/Noumea',
      [_t('Pago Pago')]: 'Pacific/Pago_Pago',
      [_t('Palau')]: 'Pacific/Palau',
      [_t('Pitcairn')]: 'Pacific/Pitcairn',
      [_t('Pohnpei')]: 'Pacific/Pohnpei',
      [_t('Port Moresby')]: 'Pacific/Port_Moresby',
      [_t('Rarotonga')]: 'Pacific/Rarotonga',
      [_t('Saipan')]: 'Pacific/Saipan',
      [_t('Tahiti')]: 'Pacific/Tahiti',
      [_t('Tarawa')]: 'Pacific/Tarawa',
      [_t('Tongatapu')]: 'Pacific/Tongatapu',
      [_t('Wake')]: 'Pacific/Wake',
      [_t('Wallis')]: 'Pacific/Wallis',
    },
  } as const,

  UTC: {
    groupName: _t('UTC'),
    zones: {
      [_t('UTC')]: 'UTC',
    },
  } as const,
});

export default timezones;
